// extracted by mini-css-extract-plugin
export default {"introText":"styles_introText__0hhly","introTextText":"styles_introTextText__ek4c8","introTextSuggestionsList":"styles_introTextSuggestionsList__OqH08"};